export function addOpacidade(color: string, opacity: number) {
    let r, g, b;

    color = color.replace('#', '');

    if (color.length === 3) {
        r = parseInt(color.substring(0, 1) + color.substring(0, 1), 16);
        g = parseInt(color.substring(1, 2) + color.substring(1, 2), 16);
        b = parseInt(color.substring(2, 3) + color.substring(2, 3), 16);
    } else if (color.length === 6) {
        r = parseInt(color.substring(0, 2), 16);
        g = parseInt(color.substring(2, 4), 16);
        b = parseInt(color.substring(4, 6), 16);
    } else {
        throw new Error('Cor inválida');
    }

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

//

export function clarearCor(cor: string, fator: number = 0.5): string {
    cor = cor.replace('#', '');

    const r = parseInt(cor.substring(0, 2), 16);
    const g = parseInt(cor.substring(2, 4), 16);
    const b = parseInt(cor.substring(4, 6), 16);

    const rClaro = Math.min(255, Math.round(r + (255 - r) * fator));
    const gClaro = Math.min(255, Math.round(g + (255 - g) * fator));
    const bClaro = Math.min(255, Math.round(b + (255 - b) * fator));

    const rHex = rClaro.toString(16).padStart(2, '0');
    const gHex = gClaro.toString(16).padStart(2, '0');
    const bHex = bClaro.toString(16).padStart(2, '0');

    return `#${rHex}${gHex}${bHex}`;
}

//

export function escurecerCor(cor: string, fator: number = 0.5): string {
    cor = cor.replace('#', '');
  
    const r = parseInt(cor.substring(0, 2), 16);
    const g = parseInt(cor.substring(2, 4), 16);
    const b = parseInt(cor.substring(4, 6), 16);
  
    const rEscuro = Math.max(0, Math.round(r - (r * fator)));
    const gEscuro = Math.max(0, Math.round(g - (g * fator)));
    const bEscuro = Math.max(0, Math.round(b - (b * fator)));
  
    const rHex = rEscuro.toString(16).padStart(2, '0');
    const gHex = gEscuro.toString(16).padStart(2, '0');
    const bHex = bEscuro.toString(16).padStart(2, '0');
  
    return `#${rHex}${gHex}${bHex}`;
  }